import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { combineLatest, filter, of, startWith, switchMap } from 'rxjs';
import { AnalyticsService } from 'analytics';
import { UserService } from 'auth-data-access';
import { SliceClass } from 'interfaces';
import { Product, ProductService } from 'product-shared';
import { MetaService } from 'utils';
import { SlicesComponent } from '../components/slices/slices.component';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  imports: [SlicesComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingPageComponent {
  private route = inject(ActivatedRoute);
  private meta = inject(MetaService);
  private cdr = inject(ChangeDetectorRef);
  private productService = inject(ProductService);
  private userService = inject(UserService);
  private router = inject(Router);
  private analyticsService = inject(AnalyticsService);
  private platformId = inject(PLATFORM_ID);
  slices: SliceClass[];

  constructor() {
    this.route.data.subscribe(({ cmsData }) => {
      if (cmsData) {
        this.slices = cmsData.slices;
        this.meta.setTitle(cmsData.title);
        this.meta.setDescription(cmsData.metaDescription);
        this.meta.setRobotsNoIndex(cmsData.metaRobotsNoIndex);
        const pageProductCode: string = cmsData.productCode;

        if (isPlatformBrowser(this.platformId)) {
          this.setupAnalytics(pageProductCode);
        }
      }

      this.cdr.markForCheck();
    });
  }

  private setupAnalytics(productCode?: string) {
    const getProductCall$ = productCode ? this.productService.getPCProductByCode(productCode) : of(null);
    const visitorId = this.userService.getVisitorId();
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        startWith(this.router.url), // Trigger on initial load
        switchMap(() => combineLatest([this.userService.getAccount(), getProductCall$]))
      )
      .subscribe(([account, PCproduct]) => {
        let product: Product;
        if (PCproduct) {
          product = new Product(PCproduct);
        }
        this.analyticsService.addOriginalLocation();

        if (account) {
          const userDataAnalytics = this.analyticsService.buildUserData(account, visitorId);
          this.analyticsService.pageView({
            product,
            userDataAnalytics,
            visitorId,
            account,
          });
        } else {
          this.analyticsService.pageView({ product, visitorId });
        }
      });
  }
}
